'use strict';

brandService.$inject = ["Brand", "$http", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.brandService = brandService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function brandService(Brand, $http, api) {
    return {
        getAll: getAll,
        getById: getById
    };

    function getAll() {
        return api.brands.list().$promise.then(function (resources) {
            return _lodash2.default.map(resources, function (resource) {
                return Brand.create(resource);
            });
        });
    }

    function getById(id) {
        return api.brands.get({ id: id }).$promise.then(function (resource) {
            return Brand.create(resource);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/brandService.js
// module id = 801
// module chunks = 0